import React, { useState, useEffect } from "react";
import { Button, Modal, Checkbox } from "antd";
import { Copy, Info } from "react-feather";

import GodaddyImg from "../../../../assets/images/godaddy.png";
import NamecheapImg from "../../../../assets/images/namecheap.png";
import HostingerImg from "../../../../assets/images/hostinger.png";
import GoogleImg from "../../../../assets/images/google.png";

import CustomDomainImg from "../../../../assets/images/customDomain.png";

const CustomDomainData = [
  {
    id: 1,
    name: "goDaddy",
    link: "https://www.youtube.com/embed/tRtT2VDddPE?si=hHZbB6wiZwnP9Irm",
    image: GodaddyImg,
  },
  {
    id: 2,
    name: "Google",
    link: "https://www.youtube.com/embed/s83ot5M8_c4?si=Hm-4bVyizAPM2e_j",
    image: GoogleImg,
  },
  {
    id: 3,
    name: "Hostinger",
    link: "https://www.youtube.com/embed/2k2lbqSkhTI?si=CavTkFIVw1JQh3q4",
    image: HostingerImg,
  },
  {
    id: 4,
    name: "Namecheap",
    link: "https://www.youtube.com/embed/23YmpYdEoUE?si=x1c_EgZcRO2ptW_M",
    image: NamecheapImg,
  },
];

export default function DomainInfo() {
  const [link, setLink] = useState("bellacucina.com");
  const [open, setOpen] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [checkbox, setCheckbox] = useState(false);

  useEffect(() => {
    if (selectedDomain) {
      setOpen(true);
    }
  }, [selectedDomain]);

  return (
    <div>
      <div>
        <p className="text-left" style={{ color: "#3A3A3A", fontSize: "20px" }}>
          Instructions to use your domain
        </p>
      </div>
      <div className="d-flex justify-space-between mt-2 mb-2">
        {CustomDomainData.map((item) => (
          <img
            alt={item.name}
            src={item.image}
            className="cursor-pointer"
            onClick={() => setSelectedDomain(item)}
          />
        ))}
      </div>
      <div className="text-left mb-2">
        <Checkbox
          onChange={(e) => setCheckbox(e.target.value)}
          className="checkbox-plan"
          value={checkbox}
        >
          <span
            className="text-left"
            style={{ color: "#C32340", fontSize: "20px" }}
          >
            Don't have provider listed
          </span>
        </Checkbox>
      </div>
      <div>
        <div className="paid-plan-container">
          <div className="d-flex items-center">
            <span style={{ color: "#FFD574" }}> Publish on:</span>{" "}
            <Info className="ml-1" />
          </div>
          <div
            onClick={() => {
              navigator.clipboard.writeText(link);
            }}
            className="mt-1 copy-clipboard-container"
          >
            <Copy className="mr-1 cursor-pointer" size={26} />
            {link}
          </div>
          <div>
            <Button
              type="primary"
              className="custom-btn mt-2"
              onClick={() => {}}
            >
              Open Website
            </Button>
          </div>
        </div>

        <img alt="publish" src={CustomDomainImg} className="img-bg-container" />
      </div>
      <Modal
        title={<div className="mt-1"></div>}
        centered
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        width={1000}
        maskClosable
        destroyOnClose
      >
        <iframe
          height={520}
          width="100%"
          src={selectedDomain?.link}
          title={selectedDomain?.name}
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media;"
          allowfullscreen
        ></iframe>
      </Modal>
    </div>
  );
}
